/**
 * @file
 * A JavaScript file containing the sticky functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.siteHeader = {
    attach: function (context) {
      var didScroll;
      var lastScrollTop = 0;
      var delta = 15;
      var header = $("header.simple-menu", context);
      var navbarHeight = header.outerHeight();

      var iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ];

      if (navigator.platform) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            $("#main-nav").addClass("ios-device");
          }
        }
      }

      // on scroll, let the interval function know the user has scrolled
      $(window).on("scroll", function (event) {
        didScroll = true;
        if ($(".toggle-expand--open").length) {
          $(window).scrollTop(0);
          $("html").css("scroll-behavior", "unset");
        } else {
          $("html").css("scroll-behavior", "smooth");
        }
      });

      // run hasScrolled() and reset didScroll status
      setInterval(function () {
        if (didScroll) {
          hasScrolled();
          didScroll = false;
        }
      }, 250);

      function hasScrolled() {
        var st = $(window).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta) {
          return;
        }

        // If current position > last position AND scrolled past navbar...
        if (
          !$("body").hasClass("body-menu-hover") &&
          st > lastScrollTop &&
          st > navbarHeight + 100
        ) {
          // Scroll Down
          header.removeClass("nav-down search-open").addClass("nav-up");
        } else {
          // Scroll Up
          // If did not scroll past the document (possible on mac)...
          if (
            $("body").hasClass("body-menu-hover") ||
            st + $(window).height() < $(document).height()
          ) {
            header.removeClass("nav-up").addClass("nav-down");
          }
        }

        lastScrollTop = st;
      }

      if ($(window).width() < 768) {
        $(".header-top").appendTo("#main-nav");
      }
    },
  };
})(Drupal, jQuery);
